import * as React from 'react';
import Button from '../Button/Button';
import type { InfoModalProps } from '../InfoModal/InfoModal';
import InfoModal from '../InfoModal/InfoModal';

import TrashIcon from '../../../assets/studio/icon-trash-confirm.svg';

import './confirmation-modal.scss';

export type ConfirmationModalProps = Omit<InfoModalProps, 'footer' | 'showConfirmButton'> & {
    onSelection: (status: boolean) => void;
    confirmTitle?: string;
    confirmIcon?: JSX.Element;
    isConfirmProcessing?: boolean;
};

function ConfirmationModal(props: ConfirmationModalProps): JSX.Element {
    const { icon = <TrashIcon />, confirmTitle = 'Delete', isConfirmProcessing } = props;
    return (
        <InfoModal
            {...props}
            icon={icon}
            onClose={() => {
                props.onSelection(false);
                props.onClose?.();
            }}
            footer={
                <>
                    <Button
                        disabled={props.isConfirmProcessing}
                        buttonSize="small"
                        type="button"
                        buttonType="tertiary"
                        onClick={() => props.onSelection(false)}
                        data-testid="confirmation-modal-cancel-button"
                    >
                        Cancel
                    </Button>
                    <Button
                        className="confirmation-modal__confirm-button"
                        buttonSize="small"
                        type="button"
                        buttonType="secondary"
                        loading={isConfirmProcessing}
                        onClick={() => {
                            props.onSelection(true);
                        }}
                        icon={props.confirmIcon}
                        data-testid="confirmation-modal-confirm-button"
                    >
                        {confirmTitle}
                    </Button>
                </>
            }
        />
    );
}

export default ConfirmationModal;
